import React from 'react';
import { dictionaryStats, languageTiers } from '../data/siteContent';

/**
 * Second ceremonial band. Language support is where a reader like this either
 * earns trust or loses it, so the tiers are stated plainly — including the one
 * that is built but not yet downloadable.
 */
const DictionarySection: React.FC = () => {
  return (
    <section id="languages" className="band-night section-y">
      <div className="shell">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-gutter">
          <div className="lg:col-span-5">
            <p className="kicker text-primary-lift">Offline dictionaries</p>
            <h2 className="display-lg mt-5 text-[2.25rem] text-white sm:text-[2.85rem]">
              One language done properly, twenty done usefully.
            </h2>
            <p className="prose-reading mt-6 text-white/70">{dictionaryStats.description}</p>

            <dl className="mt-9 grid grid-cols-3 gap-px bg-white/15">
              <div className="bg-night px-4 py-5">
                <dt className="kicker text-white/60">Headwords</dt>
                <dd className="mt-2 font-display text-xl text-white">{dictionaryStats.headwords}</dd>
              </div>
              <div className="bg-night px-4 py-5">
                <dt className="kicker text-white/60">Pack size</dt>
                <dd className="mt-2 font-display text-xl text-white">{dictionaryStats.size}</dd>
              </div>
              <div className="bg-night px-4 py-5">
                <dt className="kicker text-white/60">Version</dt>
                <dd className="mt-2 font-display text-xl text-white">{dictionaryStats.version}</dd>
              </div>
            </dl>
            <p className="kicker mt-4 text-white/60">{dictionaryStats.language}</p>
          </div>

          <ol className="list-none lg:col-span-7">
            {languageTiers.map((tier) => (
              <li
                key={tier.tier}
                className="border-t border-white/15 py-8 first:border-t-0 first:pt-0 last:pb-0"
              >
                <div className="flex flex-wrap items-baseline gap-x-4 gap-y-2">
                  <h3 className="display-sm text-xl text-white">{tier.tier}</h3>
                  {!tier.published && (
                    <span className="border border-white/25 px-2 py-0.5 font-body text-[0.625rem] font-semibold uppercase tracking-small-caps text-white/60">
                      Not downloadable yet
                    </span>
                  )}
                </div>
                <p className="mt-2 font-display text-lg text-primary-lift">{tier.languages}</p>
                <p className="prose-note mt-3 max-w-xl text-white/65">{tier.description}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default DictionarySection;
